import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { offer } from '../data/offer';
const features = ['Catequesis 1 · 40 páginas', 'Catequesis 2 · 45 páginas', 'Confirmación · 35 páginas', 'BONUS PREMIUM: ESI para Escuela Católica · 42 páginas', '162 páginas en total · listas para imprimir', 'Acceso inmediato y de por vida'];
const reassurances = ['120 páginas de Catequesis', 'Bonus Premium de 42 páginas', '162 páginas en total', 'Material digital', 'Listo para imprimir'];
export function PurchaseSection() {
  return <section id="compra" className="py-10 px-4 bg-black text-white text-center" data-id="element-117" data-mp="352rsu936g8ik">
      <div className="max-w-2xl mx-auto" data-id="element-118" data-mp="3jsz5272lcvat">
        <h2 className="text-[20px] md:text-2xl font-black mb-1 text-white" data-id="element-119" data-mp="3euxnjqktd41g">
          ACCEDÉ AHORA A CATEQUESIS LISTAS
        </h2>
        <p className="text-base text-gray-300 mb-6" data-id="element-120" data-mp="3svgoyeurxbun">
          3 materiales completos + Bonus Premium
        </p>

        <div className="relative flex flex-col rounded-3xl p-6 md:p-7 text-left shadow-2xl border-2 bg-gray-900 border-[#157C8B]" data-id="element-121" data-mp="3oues24obxbvu">
          <h3 className="text-2xl md:text-[26px] font-black mb-4 text-white leading-tight" data-id="element-122" data-mp="y87v5vhkd64k">
            Megapack Catequesis Listas
          </h3>

          <ul className="space-y-2 mb-6" data-id="element-123" data-mp="175i4vceqgn7d">
            {features.map(f => <li key={f} className="flex items-start text-sm md:text-base" data-id="element-124" data-mp="1c5mld2fn5hxl">
                <CheckIcon className="w-5 h-5 mr-2 flex-shrink-0 mt-0.5 text-[#4FD1DB]" data-id="element-125" data-mp="1c3jopzjzgqjw" />
                <span className="text-gray-200" data-id="element-126" data-mp="1h4h82fgqbqmz">{f}</span>
              </li>)}
          </ul>

          <div className="flex items-end justify-center h-48 mb-5" data-id="element-127" data-mp="1l4huondzf854">
            <img src={offer.heroImage} alt="Megapack Catequesis Listas" className="h-full w-auto object-contain drop-shadow-xl" data-id="element-128" data-mp="1py2jppxlkrs6" />
          </div>

          <div className="mb-4" data-id="element-129" data-mp="1uy8dbbnfgocw">
            <div className="flex items-center gap-2 mb-1" data-id="element-130" data-mp="1zvqqxfce3rr8">
              <span className="text-lg font-bold line-through text-gray-500" data-id="element-131" data-mp="1zt49mnzp5xvt">
                {offer.currency} {offer.oldPrice}
              </span>
              <span className="bg-[#EE6A4D] text-white text-xs font-black px-2.5 py-1 rounded-full" data-id="element-132" data-mp="1f5d43e2q01ip">
                {offer.discount}
              </span>
            </div>
            <span className="text-sm font-bold align-top mr-1 text-gray-400" data-id="element-133" data-mp="1ovzd2pfxltsf">
              {offer.currency}
            </span>
            <span className="text-4xl md:text-5xl font-black text-white" data-id="element-134" data-mp="1k4ze7en951na">
              {offer.price}
            </span>
            <p className="text-xs mt-1 text-gray-400" data-id="element-135" data-mp="1xvclrfw8eec3">
              Pago único · Acceso inmediato
            </p>
          </div>

          <CTAButton href={offer.checkoutUrl} className="w-full text-lg md:text-xl py-4" data-id="element-136" data-mp="1szno5i3rv7if">
            👉 QUIERO CATEQUESIS LISTAS
          </CTAButton>
        </div>

        <div className="max-w-md mx-auto mt-8" data-id="element-137" data-mp="22x20b5inxa4x">
          <CTAButton href={offer.whatsappUrl} className="w-full text-lg md:text-xl py-4 mb-4 flex items-center justify-center gap-3 !bg-gradient-to-r !from-[#25D366] !to-[#128C7E] !shadow-[0_0_20px_rgba(37,211,102,0.4)]" data-id="element-138" data-mp="dgswhnj20pd9">
            <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-139" data-mp="2k4t673sf0trt">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-140" data-mp="2p3cu39qkkfmt" />
            </svg>
            COMPRA POR WHATSAPP
          </CTAButton>

          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1 text-sm font-bold text-gray-300" data-id="element-141" data-mp="1cr7nptgtocuv">
            {reassurances.map(item => <span key={item} className="flex items-center" data-id="element-142" data-mp="1315xow4wskdb">
                <span className="text-[#4FD1DB] mr-1" data-id="element-143" data-mp="12zl4b9ubz7h1">✔</span> {item}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}